import { FC, useState, useContext, useEffect } from 'react';

import { Col, Row } from 'antd';
import { useAppSelector } from 'hooks/redux';
import SwitchButton from 'components/SwitchButton/SwitchButton';
import HalfScreenModal from 'components/HalfScreenModal/HalfScreenModal';
import { ERROR_MESSAGE_PLAN_EDITING } from 'constants/commonConstants';
import { NotificationContext } from 'context/NotificationContext';
import FixedAlertMessage from 'components/FixedAlert/FixedAlertMessage';
import LinkButton from 'components/buttons/LinkButton/LinkButton';
import { ReactComponent as PopoutIcon } from 'images/icons/icon-popout.svg';
import styles from './linkedguideLinkEditor.module.less';

type BenefitsEnrollEditorProps = {
  isOpenModal: boolean;
  closeModal: Function;
  onSaveLinkedGuideLink: Function;
  linkedGuideButton: boolean;
};

const LinkedGuideLinkEditor: FC<BenefitsEnrollEditorProps> = (
  props: BenefitsEnrollEditorProps
) => {
  const { isOpenModal, closeModal, onSaveLinkedGuideLink, linkedGuideButton } =
    props;
  const translations = useAppSelector(
    (state) => state.benguide.data.translations
  );
  const language = useAppSelector((state) => state.benguide.data?.language);
  const employerName = useAppSelector(
    (state) => state.basicInfo.layoutBenefitGuide?.employerName
  );
  const [isChecked, setIsChecked] = useState<boolean>(linkedGuideButton);
  const notificationFlag = useContext(NotificationContext);

  useEffect(() => {
    setIsChecked(linkedGuideButton);
  }, [linkedGuideButton]);

  const closeBenefitsEnrollModal = () => {
    if (linkedGuideButton) {
      setIsChecked(true);
    } else {
      setIsChecked(false);
    }
    closeModal();
  };

  const handleDisplayEnroll = (checked: boolean) => {
    setIsChecked(checked);
  };

  const saveEnrollmentLink = async () => {
    try {
      if (isChecked) {
        onSaveLinkedGuideLink('', isChecked);
        closeModal();
      } else {
        onSaveLinkedGuideLink('', isChecked);
        closeModal();
      }
    } catch (error: any) {}
  };

  const openLinkedDbg = () => {
    let hash = '';
    if (language === 'SPANISH') {
      hash = translations['ENGLISH']?.[0]?.urlHash || '';
    } else {
      hash = translations['SPANISH']?.[0]?.urlHash || '';
    }

    if (!hash) {
      return;
    }

    return window.open(
      window.location.origin + `/${hash}/${employerName}`,
      '_blank'
    );
  };

  const getLinkedDbgName = () => {
    let name = '';
    if (language === 'SPANISH') {
      name = translations['ENGLISH']?.[0]?.name || '';
    } else {
      name = translations['SPANISH']?.[0]?.name || '';
    }

    if (!name) {
      return;
    }

    return name;
  };

  return (
    <HalfScreenModal
      width="550px"
      title={`Add ${
        language === 'SPANISH' ? 'English' : 'Spanish'
      } Guide Button`}
      visible={isOpenModal}
      onCancel={closeBenefitsEnrollModal}
      footerStyles={styles.benefitsEnrollFooter}
      onSubmit={saveEnrollmentLink}
    >
      {notificationFlag && (
        <FixedAlertMessage
          type={'error'}
          message={ERROR_MESSAGE_PLAN_EDITING}
        />
      )}
      <div className={styles.benefitsLinkWrapper}>
        Add a button link to the{' '}
        {language === 'SPANISH' ? 'English' : 'Spanish'} version of this guide
        accessible from the homepage. This button will only appear to users
        after the {language === 'SPANISH' ? 'English' : 'Spanish'} guide has
        been published.
      </div>
      <Row className={styles.benefitSwitchWrapper}>
        <span className={styles.subHeader}>
          Display {language === 'SPANISH' ? 'English' : 'Spanish'} Guide Button?
        </span>
        <SwitchButton onChange={handleDisplayEnroll} checked={isChecked} />
      </Row>
      <Row className={styles.benefitSwitchWrapper}>
        <Col>
          <span className={styles.subHeader}>
            {language === 'SPANISH' ? 'English' : 'Spanish'} Guide :
          </span>
        </Col>
        <Col>
          <Row>{getLinkedDbgName()}</Row>
          <Row>
            <LinkButton className={styles.previewBtn} onClick={openLinkedDbg}>
              Preview <PopoutIcon />
            </LinkButton>
          </Row>
        </Col>
      </Row>
    </HalfScreenModal>
  );
};

export default LinkedGuideLinkEditor;
